import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import concat from 'utils/immutable/concat';
import { createPackageCards } from 'components/packageCard/PackageCardFactory';
import { DEAL as ROUTE_KEY_DEAL } from 'constants/routesKeys';
import { ADVERTS_PACKAGE } from 'components/packageCard/constants/packageTypes';
import DealsComponent from 'routes/deals/DealsComponent';
import fetchDeals from 'state/deals/operations/fetchDeals';
import fetchAdverts from 'state/adverts/operations/fetchAdverts';
import { getRoutePathByRouteKey } from 'state/routes/operations';
import getSelectedRooms from 'state/selectRooms/operations/getSelectedRooms';
import { updateSavedPackages } from 'state/savedPackages/operations';
import AdvertsTemplateComponent from './AdvertsTemplateComponent';

class AdvertsTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      packages: [],
      currentPage: 0,
      isLoading: false,
      pathToDealPage: null,
    };

    this.handleOnLoadMore = this.handleOnLoadMore.bind(this);
    this.scrollWrapRef = React.createRef();
  }

  componentDidMount() {
    const { adverts, deals, getRoutePathByRouteKey, fetchDeals, fetchAdverts } = this.props;

    this.setState({
      pathToDealPage: getRoutePathByRouteKey(ROUTE_KEY_DEAL),
    });

    if (deals === null) {
      fetchDeals();
    }

    if (adverts.adverts.length === 0) {
      fetchAdverts();
      return;
    }

    this.handleOnLoadMore();
  }

  componentDidUpdate(prevProps) {
    const { adverts } = this.props;
    const { adverts: prevAdverts } = prevProps;

    if (adverts.filteredAdvertsTimeStamp !== prevAdverts.filteredAdvertsTimeStamp) {
      this.setState({
        packages: [],
        currentPage: 0,
        isLoading: false,
      });
    }
  }

  handleOnLoadMore() {
    const { adverts } = this.props;
    const { currentPage } = this.state;

    if (adverts.filteredAdverts.length === 0) {
      return;
    }

    this.setState({ isLoading: true });
    const nextPage = currentPage + 1;
    const nextPackages = adverts.filteredAdverts.slice(10 * currentPage, 10 * nextPage);
    this.handlePackageCardCreation(nextPackages, nextPage);
  }

  handlePackageCardCreation(packages, page) {
    const { getSelectedRooms, addSavedPackages, removeSavedPackages } = this.props;

    const packagesCards = createPackageCards({
      packages,
      packageType: ADVERTS_PACKAGE,
      configuration: {
        maxWidth: '742px',
        target: '_self',
        wrapPackage: true,
        small: true,
      },
      data: {
        selectedRooms: getSelectedRooms(),
      },
      events: {
        onClickAddHearted: addSavedPackages,
        onClickRemoveHearted: removeSavedPackages,
      },
    });

    this.setState((state) => ({
      currentPage: page ? page : state.currentPage,
      packages: concat(state.packages, packagesCards),
      isLoading: false,
    }));
  }

  render() {
    const { adverts, deals, content ,isHolidayPirates } = this.props;
    const { packages, isLoading, pathToDealPage } = this.state;
    const _hasMore = packages.length !== adverts.filteredAdverts.length;
    const hasMore = _hasMore && !isLoading;
    const showLoader = _hasMore || isLoading;

    return (
      <Fragment>
        {deals && deals.length > 0 && <DealsComponent deals={deals} pathToDealPage={pathToDealPage} />}
        <AdvertsTemplateComponent
          packages={packages}
          hasMore={hasMore}
          showLoader={showLoader}
          scrollWrapRef={this.scrollWrapRef}
          title={content.title}
          onLoadMore={this.handleOnLoadMore}
          isHolidayPirates={isHolidayPirates}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    adverts: state.adverts,
    deals: state.deals.value,
    isHolidayPirates : state.settings.value.customSettings && state.settings.value.customSettings.isHolidayPirates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAdverts() {
      dispatch(fetchAdverts());
    },
    fetchDeals() {
      dispatch(fetchDeals());
    },
    getRoutePathByRouteKey(routeKey) {
      return dispatch(getRoutePathByRouteKey(routeKey));
    },
    getSelectedRooms() {
      return dispatch(getSelectedRooms());
    },
    addSavedPackages(packet) {
      dispatch(updateSavedPackages(null, packet));
    },
    removeSavedPackages(id) {
      dispatch(updateSavedPackages(id, null));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvertsTemplate);
